import React from 'react'
import about from "../ui/images/about.svg"

function About() {
    return (
        <div className="about">
            <h1 className="about-title">Github Finder</h1>
            <p className="about-version">Version 0.1</p>
            <h5 className="about-name"> Handcrafted by SHeiKH </h5>
            <div>
                <a href="mailto:abdul.layeeq359@gmailcom" className="btn">Work with me</a>
            </div>
            <img src={about} alt="about" className="spinner spinner-m" />
        </div>
    )
}

export default About
